import type { ReactNode } from "react";
import styles from "./PageHeader.module.css";

export type PageHeaderProps = {
  /** Surtitre court : la rubrique de l'écran (« Portefeuille »). */
  eyebrow?: ReactNode;
  /** Titre de l'écran. Rendu dans l'unique `<h1>` de la page. */
  title: ReactNode;
  /** Une phrase : ce que l'écran permet de faire. */
  description?: ReactNode;
  /** Actions de niveau écran, alignées à droite. */
  actions?: ReactNode;
};

/**
 * En-tête d'écran.
 *
 * Chacun des cinq écrans commence par là : c'est ce qui leur donne le même
 * rythme vertical, et ce qui garantit un `<h1>` unique par page.
 */
export function PageHeader({ eyebrow, title, description, actions }: PageHeaderProps) {
  return (
    <header className={styles.entete}>
      <div className={styles.textes}>
        {eyebrow !== undefined && <span className={styles.surtitre}>{eyebrow}</span>}
        <h1 className={styles.titre}>{title}</h1>
        {description !== undefined && (
          <p className={styles.description}>{description}</p>
        )}
      </div>
      {actions !== undefined && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}
